<section class="card">
  <div class="widget-container {{ bulletClass }}">
    <div class="bullet-box">
      @if (loading) {
        <div class="loading-spinner">
          <mat-spinner [diameter]="20"></mat-spinner>
        </div>
      } @else {
        <div class="bullet"></div>
      }
    </div>
    <div class="status">
      <span class="value">{{ value == null ? '...' : value }} Circuit{{ (value == 1 ? '' : 's') }}</span>
      <span class="title">{{ title }}</span>
    </div>
  </div>
</section>
